import React, { useEffect, useState } from "react";

import InboxIcon from "@mui/icons-material/MoveToInbox";
import {
  Box,
  Button,
  Card,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  Fab,
  Tooltip,
} from "@mui/material";
import { createAction } from "@reduxjs/toolkit";
import axios from "axios";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import { Navigate, useNavigate } from "react-router-dom";

import HeaderComponent from "../components/header/index.tsx";

import { Navigation } from "../utility/routes.js";
import FooterComponent from "../components/footer/footerComponent.js";
import { useDispatch } from "react-redux";
import { SessionExpiryPopup } from "../utility/SessionExpiryPopup.js";
import {
  getAccessToken,
  getAccessTokenExpiry,
} from "../utility/SessionManager.js";
import dayjs from "dayjs";

const flushStore = createAction("FLUSH_STORE");

const Layout = () => {
  let sidebarList = [];
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [IfSessionExpiry, setIfSessionExpiry] = useState(false);
  const [expireAt, setExpireAt] = useState(getAccessTokenExpiry(window));

  sidebarList = [
    {
      title: "policy Kit",
      icon: InboxIcon,
      to: "/policy-kit",
    },
  ];

  useEffect(() => {
    if (getAccessToken(window)) {
      const checkSessionExpiry = () => {
        const timeDiff = dayjs(getAccessTokenExpiry(window)).diff(dayjs());
        if (timeDiff < 1) {
          setIfSessionExpiry(true);
          clearInterval(intervalId);
        }
      };

      const intervalId = setInterval(checkSessionExpiry, 1000 * 60 * 60); // Check every minute

      return () => clearInterval(intervalId);
    }
  }, [getAccessTokenExpiry(window), getAccessToken(window)]);

  return (
    <>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <HeaderComponent />
        {getAccessToken(window) && (
          <SessionExpiryPopup
            IfSessionExpiry={IfSessionExpiry}
            setIfSessionExpiry={setIfSessionExpiry}
          />
        )}
        <Box
          sx={{
            disply: "flex",
            flexDirection: "row",
            width: "100%",
          }}
        >
          <Box sx={{ backgroundColor: "#F2F2F5", width: "100%" }}>
            <Navigation />
            <FooterComponent />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Layout;
